import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./authContext";
import PipelineForm from "./components/form";
import SignedOut from "./pages/SignedOut";
import RequestAccount from "./pages/RequestAccountPages/RequestAccount";
import VerifyEmail from "./pages/RequestAccountPages/VerifyEmail";
import SignIn from "./pages/signInPages/SignIn";
import ForgotPassword from "./pages/signInPages/ForgotPassword";
import ResetPassword from "./pages/signInPages/ResetPassword";
import AdminDashboard from "./pages/Admin/AdminDashboard.js";
import ReportDownloader from "./pages/ReportDownloader";
// XXX Realtime is disabled on the InfauxTech FIND instance.
// import RealtimeDashboards from "./pages/RealtimeDashboards";
import PublicReports from "./pages/PublicReports";

import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
// Configure Amplify with your custom React Auth setup
Amplify.configure(awsconfig);

function Gate() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // If already signed in, go straight to app
  useEffect(() => {
    if (!loading && user) navigate("/main", { replace: true });
  }, [loading, user, navigate]);

  if (loading) return <div style={{ padding: 16 }}>Loading…</div>;

  // Landing page (no auto sign-in)
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <img src="infauxtech_logo_rectangle.png" alt="Media Forensics Hub" className="w-40 mx-auto mb-6" />
        <h2 className="text-2xl font-bold text-purple-800 mb-4">Welcome to FIND</h2>

        <button
          onClick={() => navigate("/login")}
          className="w-full bg-purple-700 text-white font-semibold py-2 rounded-lg hover:bg-purple-800"
        >
          Sign in
        </button>

        <p className="text-gray-600 mt-4">
          Don't have an account?{" "}
          <a href="/request-account" className="text-purple-700 font-semibold hover:underline">
            Request one
          </a>
        </p>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  return user ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Gate />} />
          <Route path="/login" element={<SignIn />} /> {/* Now uses custom SignIn */}

          <Route
            path="/main"
            element={
              <Protected>
                <div className="App"><PipelineForm /></div>
              </Protected>
            }
          />

          {/* XXX Realtime is disabled on the InfauxTech FIND instance. */}
          {/* <Route
            path="/realtime"
            element={
              <Protected>
                <RealtimeDashboards />
              </Protected>
            }
          /> */}

           {/* PROTECTED ADMIN ROUTE */}
          <Route
            path="/admin"
            element={
              <Protected>
                <AdminDashboard />
              </Protected>
            }
          />

          <Route
            path="/reports/:viewerName"
            element={
              <Protected>
                <ReportDownloader />
              </Protected>
            }
          />

          <Route
            path="/public"
            element={
              <Protected>
                <PublicReports />
              </Protected>
            }
          />

          <Route path="/signed-out" element={<SignedOut />} />
          <Route path="/request-account" element={<RequestAccount />} />
          <Route path="/verify" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
